"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject"); // tslint:disable:max-classes-per-file

/**
 * Mainly sub-set of PriceListRow's fields which are needed in {@link PriceStats}.
 * For fields' descriptions see {@link PriceListRow}.
 */


var PriceStatsPrice =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceStatsPrice, _DomainObject_1$Domai);

  function PriceStatsPrice(id, groupOfSiteId, productId, amount, dateFrom, dateTo, promotionId) {
    var _this;

    _classCallCheck(this, PriceStatsPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceStatsPrice).call(this));
    _this.id = id;
    _this.groupOfSiteId = groupOfSiteId;
    _this.productId = productId;
    _this.amount = amount;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.promotionId = promotionId;
    return _this;
  }

  return PriceStatsPrice;
}(DomainObject_1.DomainObject);

exports.PriceStatsPrice = PriceStatsPrice;

PriceStatsPrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceStatsPrice.name);
  return {
    id: builder.id('id'),
    groupOfSiteId: builder.str('groupOfSiteId'),
    productId: builder.str('productId'),
    amount: builder.bigNum('amount'),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    promotionId: builder.opt(builder.str('promotionId'))
  };
}();
/**
 * Price statistic for some specific product, GOS and time range (ranges).
 * The meaning of every field can change according to a context.
 * The concrete meaning should be described on the place where this structure is used.
 *
 * @author Jan Gregor
 */


var PriceStats =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(PriceStats, _DomainObject_1$Domai2);

  /**
   * @param currentPrices Data of prices which were valid at the end of the given time range or after. Can be empty.
   * @param lastAmount The price that was last valid (or still is).
   * @param minAmount The lowest price. Can be null even if other prices are defined, because of different time range.
   * @param averageAmount The average price. Can be null even if other prices are defined, because of different time range.
   * @param openingAmount The lowest price valid at the computation time (release (re)opening).
   */
  function PriceStats(currentPrices, lastAmount, minAmount, averageAmount, openingAmount) {
    var _this2;

    _classCallCheck(this, PriceStats);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PriceStats).call(this));
    _this2.currentPrices = currentPrices;
    _this2.lastAmount = lastAmount;
    _this2.minAmount = minAmount;
    _this2.averageAmount = averageAmount;
    _this2.openingAmount = openingAmount;
    return _this2;
  }

  return PriceStats;
}(DomainObject_1.DomainObject);

exports.PriceStats = PriceStats;
/**
 * PriceStats with no data.
 */

PriceStats.EMPTY = new PriceStats(immutable_1.List(), null, null, null, null);

PriceStats.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceStats.name);
  return {
    currentPrices: builder.listOf(builder.obj('currentPrices', PriceStatsPrice.schema, function (mat) {
      return new PriceStatsPrice(mat.id, mat.groupOfSiteId, mat.productId, mat.amount, mat.dateFrom, mat.dateTo, mat.promotionId);
    })),
    lastAmount: builder.opt(builder.bigNum('lastAmount')),
    minAmount: builder.opt(builder.bigNum('minAmount')),
    averageAmount: builder.opt(builder.bigNum('averageAmount')),
    openingAmount: builder.opt(builder.bigNum('openingAmount'))
  };
}();